import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { FormattedMessage } from 'react-intl';
import messages from '@Locales/config/common/messages';
import * as actions from './action';
import selectors from './selector';

const NoPermissionDialog = props => {
  const { dialogOpen, setDialogState } = props;

  return (
    <div>
      <Dialog
        open={dialogOpen}
        onClose={() => setDialogState(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          <FormattedMessage {...messages.noPermissionTitle} />
        </DialogTitle>
        <DialogContent style={{ display: 'flex' }}>
          <div>⚠</div>
          <div style={{ paddingLeft: '7px' }}>
            <FormattedMessage {...messages.noPermissionMessage} />
            <br />
            <br />
            <FormattedMessage {...messages.noPermissionContact} />
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setDialogState(false)}
            color="primary"
            autoFocus
          >
            <FormattedMessage {...messages.noPermissionClose} />
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const mapStateToProps = (state, ownProps) => ({
  dialogOpen: selectors.getIsDialogOpen(state)
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setDialogState: actions.setDialogState
    },
    dispatch
  );

NoPermissionDialog.defaultProps = {
  dialogOpen: false
};

NoPermissionDialog.propTypes = {
  dialogOpen: PropTypes.bool
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NoPermissionDialog);
